export const environment = {
  production: false,
  envName: "stage",
  HIDE_CUSTOM_FILTER: false,

  API_ROOT: "api/",
  API_VERSION: "",
  API_CHANGELOG: "[1.52.0] - 2026-03-10",

  /* CDN Resource urls */
  CDN_URL: "https://cdn.smart-media.world",

  /* smart media world */
  API_URL_SUG: "https://stage-sug.smart-media.world/",
  API_URL_BASE: "https://stage-ems.smart-media.world/",
  LOGIN_URL_SUG: "https://sug.smart-media.world/login",
  LOGIN_URL_BASE: "https://ems.smart-media.world/login",
  SSO_REALM_SUG: "sug",
  SSO_REALM_BASE: "ems",
  SSO_CLIENT_ID_SUG: "smart_media_world",
  SSO_CLIENT_ID_BASE: "smart_media_world",

  sentry: {
    dsn: 'https://f5bf70da1c4b2771d568cf452d7f1a9a@sentry.sommer-gossmann.com/3',
    release: 'cf8c5ceb'
  },

  externApplicationUrls:
  {
    'sug': [
      // Briefing
      { path: 'briefing/anzeigen', url: 'https://sug-test.medienbutler.online/?query=Planung' },

      // Buchen
      { path: 'buchen/anzeigen', url: 'https://sug-test.medienbutler.online/?query=Vorschlag' },
      { path: 'buchen/anzeigentool', url: 'https://stage-auftrag.sommer-gossmann.com/login_surf' },
      { path: 'buchen/atv', url: '' },
      { path: 'buchen/digital', url: 'https://sug.cc.adunit.tech/orders/' },
        { path: 'buchen/digital/kunden', url: 'https://sug.cc.adunit.tech/customers/' },
        { path: 'buchen/digital/werbemittel', url: 'https://sug.cc.adunit.tech/creatives/' },
      { path: 'buchen/instore', url: '' },
      { path: 'buchen/mailing', url: '' },
      { path: 'buchen/ooh', url: '' },
      { path: 'buchen/prospekt', url: '' },

      // Dashboards
      { path: 'dashboards/digital_adunit', url: 'https://sug.cc.adunit.tech/reporting' },

      // Werbegebiete
      // { path: 'gebiete/bearbeiten', url: 'intern' },
      { path: 'gebiete/daten-exportieren', url: '' },
      { path: 'gebiete/mediamaps', url: 'https://test-mediamaps.sommer-gossmann.com/' },

      // Reklamation
      { path: 'reklamation', url: 'https://test-sug.mein-handzettel.de/de/login_surf' },

      // Import (Admin-Bereich)
      { path: 'import/address-updates', url: '' },
      { path: 'import/edition-updates', url: '' },
      { path: 'import/payback-data', url: '' },
      { path: 'import/distribution-data', url: '' },
      { path: 'import/competitor-locations', url: '' }
    ],
    'ems': [
      // Briefing
      { path: 'briefing/anzeigen', url: 'https://ems-test.medienbutler.online/?query=Planung' },

      // Buchen
      { path: 'buchen/anzeigen', url: 'https://ems-test.medienbutler.online/?query=Vorschlag' },
      { path: 'buchen/anzeigentool', url: 'https://stage-anzeigen.em-sourcing.com/login_surf' },
      { path: 'buchen/atv', url: '' },
      { path: 'buchen/digital', url: 'https://ems.cc.adunit.tech/orders/' },
        { path: 'buchen/digital/kunden', url: 'https://ems.cc.adunit.tech/customers/' },
        { path: 'buchen/digital/werbemittel', url: 'https://ems.cc.adunit.tech/creatives/' },
      { path: 'buchen/instore', url: '' },
      { path: 'buchen/mailing', url: '' },
      { path: 'buchen/ooh', url: '' },
      { path: 'buchen/prospekt', url: '' },
      { path: 'buchen/satellite-crm', url: 'https://sat.prospega.de/' },

      // Dashboards
      { path: 'dashboards/digital_adunit', url: 'https://ems.cc.adunit.tech/reporting' },
      { path: 'dashboards/digitalperformance', url: '' },
      { path: 'dashboards/reklamationen', url: 'https://stage-ems.smart-media.world/qm/' },

      // Werbegebiete
      // { path: 'gebiete/bearbeiten', url: 'intern' },
      { path: 'gebiete/daten-exportieren', url: '' },
      { path: 'gebiete/mediamaps', url: 'https://test-mediamaps.em-sourcing.com/' },

      // Reklamation
      { path: 'reklamation', url: 'https://test-ems.mein-handzettel.de/de/login_surf' },

      // Import (Admin-Bereich)
      { path: 'import/address-updates', url: '' },
      { path: 'import/edition-updates', url: '' },
      { path: 'import/payback-data', url: '' },
      { path: 'import/distribution-data', url: '' },
      { path: 'import/competitor-locations', url: '' }
    ]
  },
};
